class CartCounter extends HTMLElement {

  constructor() {
    super();
    this.init();
  }

  init = () => {
    window.addEventListener(Utils.CART_ADDED, () => {
      this.update();
    });
    window.addEventListener('theme.removed_to_cart', () => {
      this.update();
    });
    window.addEventListener('theme.cart_quantity_changed', () => {
      this.update();
    });
  }

  update = () => {
    axios.get(window.Shopify.routes.root + 'cart.js')
    .then((response) => {
      try {
        const cart = JSON.parse(response.request.responseText);
        this.innerHTML = cart.item_count;
      } catch (e){
        Utils.error(window.lang.errors.generic, e);
      }
    })
    .catch((error) => {
      Utils.error(error.message, error);
    });
  }
}
if (!window.customElements.get("cart-counter")) {
  window.customElements.define("cart-counter", CartCounter);
}